module.exports = __webpack_public_path__ + "media/images/icons/profile-dffab83a432ae09be01684ecc9a129a0.svg";